import { Building } from 'dataModels/building';
import { createContext, useContext, useEffect, useReducer, useState } from 'react';
import { loadStateFromStorage, saveStateToStorage } from './persistent.helper';
import { Reducer } from 'stateMgmt';

const AppContext = createContext(null);

export function useApp() {
    const context = useContext(AppContext);
    if (!context) {
      throw new Error('useApp must be used within AppProvider');
    }
    return context;
}

const emptyState = {
    building: Building(),
    ui: {
      gridSize: 0.5
    }
  };

export function AppProvider({ children }) {
    const [selectedRoomId, setSelectedRoomId] = useState(null);
    const [showGrid, setShowGrid] = useState(true);
    const [showDimensions, setShowDimensions] = useState(true);
    const [pendingRoomPosition, setPendingRoomPosition] = useState(null);

    const initialState = loadStateFromStorage() ?? emptyState;
    const [state, dispatch] = useReducer(Reducer, initialState);
    const [currentFloorId, setCurrentFloorId] = useState(state.building?.floors[0]?.id ?? 0);
  
    useEffect(() => {
      saveStateToStorage(state);
    }, [state]);
    
    const value = {
        currentFloorId,
        setCurrentFloorId,
        selectedRoomId,
        setSelectedRoomId,
        showGrid,
        setShowGrid,
        showDimensions,
        setShowDimensions,
        pendingRoomPosition,
        setPendingRoomPosition,
        building: state.building,
        ui: state.ui,
        dispatch,
    };
    
    return (
        <AppContext.Provider value={value}>
            {children}
        </AppContext.Provider>
    );
}